<template>
  <div>
    <v-card
      v-if="
        checkaccessdata.is_viewer == false && checkaccessdata.is_maker == false
      "
      class="mt-16"
      flat
    >
      <v-row justify="center" align="center">
        <v-card-title class="red--text"><h2>Access Denied</h2></v-card-title>
      </v-row>
      <v-row justify="center" align="center">
        <v-card-subtitle class="subtitle-1"
          >You do not have Permission to access.</v-card-subtitle
        >
      </v-row>
    </v-card>
    <v-card flat v-else>
      <v-card class="ma-2 mt-6">
        <v-row>
          <!-- <v-col cols="3"> -->
          <v-card-title class="ml-2 primary--text">
            <v-btn @click="back" class="ml-n2 mt-2 primary--text" text>
              <v-icon class="mt-n2 ml-2">mdi-reply</v-icon></v-btn
            >
            Admin Access
            <span
              style="
                font-style: italic;
                font-family: Times New Roman;
                font-size: 14px;
              "
              class="text-left font-weight: 20 primary--text ml-2"
              >(User Access For Corporate)</span
            >
            <!-- <v-divider vertical class="ml-5 mx-0"></v-divider> -->
          </v-card-title>

          <!-- </v-col> -->
          <v-spacer />
          <v-col cols="12" lg="2" xl="2" md="2" sm="12" xs="12" class="ml-4">
            <v-btn
              class="navbar elevation-6 white--text mt-5"
              rounded
              @click="AddAdmin = true"
            >
              <v-icon>mdi-plus</v-icon>Create
            </v-btn>
          </v-col>
        </v-row>

        <v-layout row wrap class="mb-2">
          <v-row class="ml-4">
            <v-radio-group dense v-model="radios" row class="mr-3">
              <v-radio label="Module View" value="Module"></v-radio>

              <v-radio class label="Admin View" value="AdminView"></v-radio>
            </v-radio-group>
          </v-row>
        </v-layout>
        <!-- <v-dialog v-model="firstdialog"> fdfdsf </v-dialog> -->
        <v-data-table
          :headers="headers"
          dense
          :items="moduleviewarray"
          v-if="radios == 'Module'"
        >
          <template v-slot:[`item.sl_no`]="{ item }">
            <span class="caption">
              {{ moduleviewarray.indexOf(item) + 1 }}
            </span>
          </template>
          <template v-slot:[`item.has_viewer`]="{ item }">
            <a
              class="text-decoration-underline"
              v-if="item.has_viewer > 0"
              @click="openmoduleviewer(item)"
              >{{ item.viewer_count }}</a
            >
            <span v-if="item.has_viewer == 0">NA</span>
          </template>
          <template v-slot:[`item.has_maker`]="{ item }">
            <a
              class="text-decoration-underline"
              v-if="item.has_maker != 0"
              @click="openmodulemaker(item)"
              >{{ item.maker_count }}</a
            >
            <span v-if="item.has_maker == 0">NA</span>
          </template>
          <template v-slot:[`item.has_checker`]="{ item }">
            <a
              class="text-decoration-underline"
              v-if="item.has_checker != 0"
              @click="openmodulechecker(item)"
              >{{ item.checker_count }}</a
            >
            <span v-if="item.has_checker == 0">NA</span>
          </template>
          <template v-slot:[`item.has_approver`]="{ item }">
            <a
              class="text-decoration-underline"
              v-if="item.has_approver != 0"
              @click="openmoduleapprover(item)"
              >{{ item.approver_count }}</a
            >
            <span v-if="item.has_approver == 0">NA</span>
          </template>
          <template v-slot:[`item.has_super_access`]="{ item }">
            <a
              class="text-decoration-underline"
              v-if="item.has_super_access != 0"
              @click="openmodulesuperaccess(item)"
              >{{ item.superacess_count }}</a
            >
            <span v-if="item.has_super_access == 0">NA</span>
          </template>
          <template v-slot:[`item.has_download`]="{ item }">
            <a
              class="text-decoration-underline"
              v-if="item.has_download != 0"
              @click="openmoduledownload(item)"
              >{{ item.downloader_count }}</a
            >
            <span v-if="item.has_download == 0">NA</span>
          </template>
        </v-data-table>

        <v-data-table
          :headers="headers2"
          dense
          :items="adminUserList"
          v-if="radios == 'AdminView'"
        >
          <template v-slot:[`item.sl_no`]="{ item }">
            <span class="caption">
              {{ adminUserList.indexOf(item) + 1 }}
            </span>
          </template>

          <template v-slot:[`item.status`]="{ item }">
            <span class="caption red--text" v-if="item.status == 4"
              ><b>DEACTIVE</b></span
            >
            <span class="caption green--text" v-else><b>ACTIVE</b></span>
          </template>
          <template v-slot:[`item.Action`]="{ item }">
            <v-icon color="primary" small @click="openviewer(item)"
              >mdi-account-reactivate-outline</v-icon
            >

            <v-tooltip bottom v-if="item.status == 4 && item.is_root_user != 1">
              <template v-slot:activator="{ on }">
                <v-icon
                  small
                  class="ml-3"
                  v-on="on"
                  color="success"
                  @click="showBlockUnblockConfirm(item)"
                  >mdi-account-check
                </v-icon>
              </template>
              <span>Activate</span>
              <!-- <span v-else>Deactivate</span> -->
            </v-tooltip>
            <v-tooltip bottom v-if="item.status == 1 && item.is_root_user != 1">
              <template v-slot:activator="{ on }">
                <v-icon
                  small
                  class="ml-3"
                  v-on="on"
                  color="error"
                  @click="showBlockUnblockConfirm(item)"
                >
                  mdi-account-remove
                </v-icon>
              </template>
              <span>Deactivate</span>
            </v-tooltip>
          </template>
          <template v-slot:[`item.departement_name`]="{ item }">
            <span v-for="(dep, key) in item.dep_details" :key="key">
              {{
                dep.department_name != undefined
                  ? item.dep_details.length - 1 != item.dep_details.indexOf(dep)
                    ? dep.department_name + ", "
                    : dep.department_name + "."
                  : "-"
              }}
            </span>
            <!-- <span class="caption" v-if="item.departement_name == null"
            >-</span
          >
          <span
            class="caption"
            v-if="item.departement_name != null"
            >{{ item.departement_name }}</span
          > -->
          </template>
          <template v-slot:[`item.mobile_no`]="{ item }">
            <span class="caption" v-if="item.mobile_no != null"
              >+60 {{ item.mobile_no }}</span
            >
            <span class="caption" v-if="item.mobile_no == null">-</span>
          </template>
        </v-data-table>
      </v-card>
      <v-dialog v-model="dialog" persistent max-width="600px">
        <v-card>
          <v-toolbar color="white" dark class="elevation-0">
            <v-toolbar-title class="black--text ml-2" v-if="status == 4">
              <b>Activate</b>
            </v-toolbar-title>
            <v-toolbar-title class="black--text ml-2" v-else>
              <b>Deactivate</b>
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-icon medium class="black--text mt-n4" dark @click="dialogclose()"
              >mdi-close</v-icon
            >
          </v-toolbar>
          <v-card-text class="pt-2">
            <div class="grey--text text--darken-1" style="font-size: 15px">
              <div v-if="status == 4">
                Are you sure you want to <b>ACTIVATE</b> user
                <b>{{ email }} ?</b>
              </div>
              <div v-else>
                Are you sure you want to <b>DEACTIVATE</b> user
                <b>{{ email }} ?</b>
              </div>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-spacer></v-spacer>
            <v-btn color="primary" small @click="unblocksuccess()">YES</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog persistent v-model="AddAdmin" width="1250">
        <v-toolbar dark dense class="header">
          <v-icon>mdi-account-plus</v-icon>
          <span class="ml-3">Add User</span>

          <v-spacer></v-spacer>
          <v-btn class text dark @click="close">
            <v-icon color="white" small>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card class="overflow-hidden">
          <v-divider></v-divider>
          <v-form ref="form">
            <v-row class="ml-2 mr-2 mt-2">
              <v-col cols="12" lg="4" xl="4" md="4" sm="12" xs="12">
                <v-row>
                  <v-col cols="12" lg="12" xl="12" md="12" sm="12" xs="12">
                    <v-text-field
                      label="Name *"
                      v-model="userListViewer.name"
                      v-on:keypress="isLetter($event)"
                      maxlength="100"
                      outlined
                      dense
                      :rules="[(v) => !!v || 'Required']"
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    lg="12"
                    xl="12"
                    md="12"
                    sm="12"
                    xs="12"
                    class="mt-n3"
                  >
                    <v-text-field
                      label="E-mail *"
                      v-model="userListViewer.email_id"
                      outlined
                      reqiured
                      :rules="[
                        (v) => !!v || ' E-mail is required ',
                        (v) => /.+@.+/.test(v) || ' E-mail must be valid ',
                      ]"
                      dense
                    ></v-text-field>
                  </v-col>

                  <v-col
                    cols="12"
                    lg="12"
                    xl="12"
                    md="12"
                    sm="12"
                    xs="12"
                    class="mt-n3"
                  >
                    <v-text-field
                      label="Contact Number *"
                      :rules="[
                        (v) => !!v || 'Required',
                        (v) =>
                          /^(?=[a-zA-Z0-9@._%+-]{0,30}$)[0-9 +-]{0,64}$/.test(
                            v
                          ) || 'Invalid',
                        (v) => (v && v.length < 11) || 'Invalid Contact Number',
                        (v) => (v && v.length > 8) || 'Invalid Contact Number',
                      ]"
                      maxlength="10"
                      prefix="+60"
                      @keypress="isNumber(event)"
                      v-model="userListViewer.mobile_no"
                      outlined
                      dense
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    lg="12"
                    xl="12"
                    md="12"
                    sm="12"
                    xs="12"
                    class="mt-n3"
                  >
                    <v-text-field
                      label="Designation *"
                      v-model="userListViewer.designation"
                      outlined
                      dense
                    ></v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    lg="12"
                    xl="12"
                    md="12"
                    sm="12"
                    xs="12"
                    class="mt-n3"
                  >
                    <v-select
                      v-model="selectedItems"
                      :items="getdepartmentlist"
                      :multiple="true"
                      label="Department Name *"
                      item-value="department_id"
                      item-text="department_name"
                      :close-on-select="false"
                      outlined
                      dense
                      :rules="rules.dept"
                    ></v-select>
                  </v-col>
                </v-row>
              </v-col>
              <v-divider vertical></v-divider>
              <v-col cols="12" lg="8" xl="8" md="8" sm="12" xs="12">
                <v-card-title class="mt-n7">Account Permissions</v-card-title>
                <v-data-table
                  :headers="headers1"
                  dense
                  class="mx-2"
                  hide-default-footer
                  :items="admincreatearray"
                >
                  <template v-slot:[`item.has_viewer`]="{ item }">
                    <v-simple-checkbox
                      color="primary"
                      v-if="item.element.has_viewer != 0"
                      v-model="item.has_viewer"
                      v-ripple
                      @click="check(item)"
                    ></v-simple-checkbox>
                    <span dense v-if="item.element.has_viewer == 0">NA</span>
                  </template>
                  <template v-slot:[`item.has_checker`]="{ item }">
                    <v-simple-checkbox
                      color="primary"
                      v-if="item.element.has_checker != 0"
                      v-model="item.has_checker"
                      :disabled="!item.has_viewer"
                    ></v-simple-checkbox>
                    <span dense v-if="item.element.has_checker == 0">NA</span>
                  </template>
                  <template v-slot:[`item.has_maker`]="{ item }">
                    <v-simple-checkbox
                      color="primary"
                      v-if="item.element.has_maker != 0"
                      v-model="item.has_maker"
                      :disabled="!item.has_viewer"
                    ></v-simple-checkbox>
                    <span dense v-if="item.element.has_maker == 0">NA</span>
                  </template>
                  <template v-slot:[`item.has_approver`]="{ item }">
                    <v-simple-checkbox
                      color="primary"
                      v-if="item.element.has_approver != '0'"
                      v-model="item.has_approver"
                      :disabled="!item.has_viewer"
                    ></v-simple-checkbox>
                    <span dense v-if="item.element.has_approver == '0'"
                      >NA</span
                    >
                  </template>
                  <template v-slot:[`item.has_super_access`]="{ item }">
                    <v-simple-checkbox
                      color="primary"
                      v-if="item.element.has_super_access != '0'"
                      v-model="item.has_super_access"
                      :disabled="!item.has_viewer"
                    ></v-simple-checkbox>
                    <span dense v-if="item.element.has_super_access == '0'"
                      >NA</span
                    >
                  </template>
                  <template v-slot:[`item.has_download`]="{ item }">
                    <v-simple-checkbox
                      color="primary"
                      v-if="item.element.has_download != '0'"
                      v-model="item.has_download"
                      :disabled="!item.has_viewer"
                    ></v-simple-checkbox>
                    <span dense v-if="item.element.has_download == '0'"
                      >NA</span
                    >
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-form>

          <v-card-actions>
            <v-row justify="center">
              <v-spacer />
              <v-btn
                class="primary mt-9 mr-5 elevation-6 white--text"
                :loading="isLoading"
                medium
                rounded
                @click="createadmin"
              >
                <v-icon class="mr-2 ml-n2">mdi-plus</v-icon>Add User
              </v-btn>
            </v-row>
          </v-card-actions>

          <v-card-actions></v-card-actions>
        </v-card>
      </v-dialog>
      <Viewer
        ref="viewer"
        :department_array="department_array"
        v-on:backChild="getAdminUsers"
        :is_root_user="is_root_user"
        :getdepartmentlist="getdepartmentlist"
        :show="show"
      />
      <ShowViewerModule
        @closeDialog="showdialog = false"
        :moduleItem="moduleItem"
        :showdialog="showdialog"
      />
      <MakerModule
        @closeDialog1="showdialog1 = false"
        :moduleItem1="moduleItem1"
        :showdialog1="showdialog1"
      />
      <CheckerModule
        @closeDialog2="showdialog2 = false"
        :moduleItem2="moduleItem2"
        :showdialog2="showdialog2"
      />
      <ApproverModule
        @closeDialog3="showdialog3 = false"
        :moduleItem3="moduleItem3"
        :showdialog3="showdialog3"
      />
      <SuperModule
        @closeDialog4="showdialog4 = false"
        :moduleItem4="moduleItem4"
        :showdialog4="showdialog4"
      />
      <DownloadModule
        @closeDialog5="showdialog5 = false"
        :moduleItem5="moduleItem5"
        :showdialog5="showdialog5"
      />
    </v-card>
  </div>
</template>

<script>
import Viewer from "@/Views/Admin/Viewer.vue";
import ShowViewerModule from "@/Views/Admin/ShowViewerModule.vue";
import MakerModule from "@/Views/Admin/MakerModule.vue";
import DownloadModule from "@/Views/Admin/DownloadModule.vue";

import CheckerModule from "@/Views/Admin/CheckerModule.vue";
import ApproverModule from "@/Views/Admin/ApproverModule.vue";
import SuperModule from "@/Views/Admin/SuperModule.vue";
import { apiCall } from "@/Views/APICALL/APIcall.js";
export default {
  components: {
    Viewer,
    ShowViewerModule,
    MakerModule,
    CheckerModule,
    ApproverModule,
    SuperModule,
    DownloadModule,
  },
  data: () => ({
    DepartmentRules: [],
    checkaccessdata: {},
    firstdialog: false,
    dialog: false,
    AddAdmin: false,
    radios: "Module",
    Name: "",
    email: "",
    Email: "",
    User_id: "",
    is_root_user: 0,
    designation: "",
    isLoading: false,
    department: "",
    contactnumber: "",
    tempadmincreatearray: [],
    headers: [
      { text: "SL NO", value: "sl_no", sortable: false },
      { text: "MODULES", value: "modulename", sortable: false },
      { text: "VIEWER", value: "has_viewer", sortable: false },
      { text: "MAKER", value: "has_maker", sortable: false },
      { text: "APPROVER 1", value: "has_checker", sortable: false },
      { text: "APPROVER 2", value: "has_approver", sortable: false },
      { text: "SUPER ACCESS", value: "has_super_access", sortable: false },
      { text: "DOWNLOADER", value: "has_download", sortable: false },
    ],
    count: 0,
    moduleviewarray: [],
    AdminView: "",
    desserts: [],
    first: "",
    status: {},
    rootuservalue: "",
    showdialog: false,
    showdialog1: false,
    showdialog2: false,
    showdialog3: false,
    showdialog4: false,
    showdialog5: false,
    makedisabled: false,
    admincreatearray: [],
    getdepartmentlist: [],
    Module: "",
    Department: "",
    moduleItem: {},
    moduleItem1: {},
    moduleItem2: {},
    moduleItem3: {},
    moduleItem4: {},
    moduleItem5: {},
    block_reason: "",
    show: 0,
    selectedItems: [],
    rules: {
      dept: [],
    },

    // rules: {
    //   email: [
    //     (v) => !!v || "E-mail is required",
    //     (v) => /.+@.+/.test(v) || "E-mail must be valid",
    //   ],
    // },
    // rules: {
    //   email: [
    //     (v) => !!v || "E-mail is required",
    //     (v) => /.+@.+/.test(v) || "E-mail must be valid",
    //   ],
    //   code: [(v) => !!v || "required"],
    //   newPassword: [
    //     (v) => !!v || "required !",
    //     (v) => (v && v.length >= 8) || "Min 8 characters",
    //   ],
    //   confirmPassword: [
    //     (v) => !!v || "required !",
    //     (v) => (v && v.length >= 8) || "Min 8 characters",
    //   ],
    // },
    headers2: [
      { text: "SL NO", value: "sl_no", sortable: false },
      { text: "NAME", value: "name" },
      { text: "EMAIL", value: "email_id" },
      { text: "CONTACT NUMBER", value: "mobile_no" },
      { text: "DESIGNATION", value: "designation" },
      { text: "DEPARTMENT", value: "departement_name" },

      {
        text: "STATUS",
        value: "status",
        sortable: false,
      },
      { text: "ACTION", value: "Action" },
    ],

    headers1: [
      { text: "SECTION", value: "modulename", sortable: false },
      { text: "VIEWER", value: "has_viewer", sortable: false },
      { text: "MAKER", value: "has_maker", sortable: false },
      { text: "APPROVER 1", value: "has_checker", sortable: false },
      { text: "APPROVER 2", value: "has_approver", sortable: false },
      { text: "SUPER ACCESS", value: "has_super_access", sortable: false },
      { text: "DOWNLOADER", value: "has_download", sortable: false },
    ],
    desserts1: [
      {
        Section: "Cards",
        Viewer: false,
        Maker: false,
        Checker: false,
        Apprpver: false,
      },
      {
        Section: "Corporate Funds",
        Viewer: false,
        Maker: false,
        Checker: false,
      },
      { Section: "CARD FUNDS", Viewer: false, Maker: false, Checker: false },
      { Section: "ADMIN ACCESS", Viewer: false, Maker: false, Checker: false },
      { Section: "MASTERS", Viewer: false, Maker: false, Checker: false },
    ],

    adminUserList: [],
    userListViewer: {},
    department_array: [],
    USerId: "",
  }),

  created() {
    // if (this.$store.getters.get_dialogcheck == true) {
    //   this.AddAdmin = true;
    // }
    this.checkaccess();
  },
  // mounted() {
  //    this.checkacces();
  // },
  methods: {
    async checkaccess() {
      var inputData = {
        method_name: "ACCESS",
        page_no: 0,
        record_count: 0,
        page_size: 25,
        app_code: "CPORTAL",
        method_param: {
          action: "CHECK_ACCESS",
          user_id: this.$store.getters.get_userid,
          module_code: "AACESS",
          module_type: "2",
        },
      };
      var responseData = await apiCall(inputData);

      this.checkaccessdata = responseData.data.data;
      // console.log("checkaccessdata", this.checkaccessdata);
      if (this.checkaccessdata.is_viewer == true) {
        this.adminacces();
        this.getAdminUsers();
        this.getdepartment();
      }
    },

    dialogclose() {
      this.block_reason = "";
      this.dialog = false;
    },
    showBlockUnblockConfirm(item) {
      //  console.log(item,"dsf")
      this.status = item.status;
      this.email = item.email_id;
      this.User_id = item.userid;
      this.username = item.user_name;

      this.dialog = true;
    },
    isLetter(e) {
      let char = String.fromCharCode(e.keyCode); // Get the character
      if (/^[A-Z a-z]+$/.test(char)) return true;
      // Match with regex
      else e.preventDefault(); // If not match, don't add to input text
    },
    async unblocksuccess() {
      let inputData = {
        method_name: "ACCESS",
        page_no: 0,
        record_count: 0,
        page_size: 25,
        app_code: "APORTAL",
        method_param: {
          action: "ACTDEAUSER",
          // email_id: this.email,
          user_id: this.User_id,
          corp_id: this.$store.getters.get_corpid,
        },
      };
      var responseData = await apiCall(inputData);
      // console.log("responseData", responseData.data.data);
      if (responseData.data.status_msg == "00") {
        this.$store.commit("snackbar/showMessage", {
          color: "red",
        });
        this.block_reason = "";
        this.dialog = false;
      } else {
        this.$store.commit("snackbar/showMessage", {
          content: responseData.data.status_msg,
          color: "green",
        });
        this.block_reason = "";
        this.dialog = false;

        this.getAdminUsers();
      }
    },
    back() {
      this.$router.push("/Dashboard");
    },

    check(item) {
      // console.log(item, "data");
      // for disabling
      // this.makedisabled = item.has_viewer == true ? false : true;
      // this.makedisabledapprover1 = item.has_viewer == true ? false : true;
      // this.makedisabledapprover2 = item.has_viewer == true ? false : true;

      //for unchecking
      if (item.has_viewer == false) {
        item.has_maker = false;
        item.has_checker = false;
        item.has_approver = false;
        item.has_super_access = false;
        item.has_download = false;
      }
    },
    async getdepartment() {
      var inputData = {
        method_name: "CORPONBOARD",
        page_no: 0,
        record_count: 0,
        page_size: 25,
        app_code: "CPORTAL",
        method_param: {
          action: "GDMASTER",
          corp_id: this.$store.getters.get_corpid,
        },
      };
      var responseData = await apiCall(inputData);
      if (responseData.data.data != null || responseData.data.data != "") {
        this.getdepartmentlist = responseData.data.data;
      }

      // console.log("depdata", this.getdepartmentlist);
    },
    createadmin() {
      let Items = this.selectedItems.length;
      if (this.$refs.form.validate() && Items != 0) {
        this.createAdminFn();
      } else {
        this.$store.commit("snackbar/showMessage", {
          content: "Fill the required fields *",
          color: "red",
        });
      }
      // if (Items.length > 0) {
      //   this.rules.dept = [];
      // } else if (Items.length <= 0) {
      //   this.rules.dept = [(v) => !!v || "Department Name isrequired"];
      //   console.log("this.rules.dept ", this.rules.dept);
      // }
    },
    createAdminFn() {
      var outputarray = [];
      var self = this;
      self.admincreatearray.forEach(function (ele) {
        outputarray.push({
          module_id: ele.moduleid,
          has_viewer: ele.has_viewer == true ? 1 : 0,
          has_maker: ele.has_maker == true ? 1 : 0,
          has_checker: ele.has_checker == true ? 1 : 0,
          has_approver: ele.has_approver == true ? 1 : 0,
          has_super_access: ele.has_super_access == true ? 1 : 0,
          has_download: ele.has_download == true ? 1 : 0,
        });
      });
      //console.log("outputarray", outputarray);

      this.callingcreateadminapi(outputarray);
    },
    async callingcreateadminapi(data) {
      if (this.tempadmincreatearray != data) {
        this.isLoading = true;
        var inputData = {
          method_name: "ACCESS",
          page_no: 0,
          record_count: 0,
          page_size: 25,
          app_code: "CPORTAL",
          method_param: {
            action: "CREATEU",
            user_details: {
              corp_id: this.$store.getters.get_corpid,
              name: this.userListViewer.name,
              email_id: this.userListViewer.email_id,
              ccode: this.userListViewer.ccode,
              mobile_no: this.userListViewer.mobile_no,
              designation: this.userListViewer.designation,
              department_id: this.selectedItems,
              user_id: 0,
            },
            module_access: data,
          },
        };

        var responseData = await apiCall(inputData);
        console.log("responseData", responseData);
        if (responseData.data.status == "00") {
          this.isLoading = false;
          this.AddAdmin = false;
          this.$refs.form.resetValidation();
          this.$refs.form.reset();
          this.getuserdeatils();
          this.adminacces();
          this.getAdminUsers();

          this.$store.commit("snackbar/showMessage", {
            content: responseData.data.status_msg,
            color: "green",
          });
        } else {
          this.$store.commit("snackbar/showMessage", {
            content: responseData.data.status_msg,
            color: "red",
          });
        }
        // console.log("inputData", inputData);
      }
      // console.log("sdgs", responseData);
    },
    async getuserdeatils() {
      // alert(20);
      var inputData = {
        method_name: "CORPONBOARD",
        page_no: 0,
        record_count: 0,
        page_size: 25,
        app_code: "CPORTAL",
        method_param: {
          action: "CORPLOGIN",
          email_id: this.$store.getters.get_useremail,
        },
      };
      var responseData = await apiCall(inputData);
      if (responseData.data.status == "00") {
        if (responseData.data.data != null || responseData.data.data != "") {
          var rowlist = responseData.data.data;
        }
        this.$store.commit("SET_Cusdetails", rowlist);
        // rowlist.department_count = "1";
        if (rowlist.expense_approver_count == "1") {
          this.$router.push("/AdminAccess");
        }
      }
      // console.log("getuserdeatils", responseData);
    },
    async getAdminUsers() {
      var inputData = {
        method_name: "ACCESS",
        page_no: 0,
        record_count: 0,
        page_size: 25,
        app_code: "CPORTAL",
        method_param: {
          action: "GETUSRS",
          corp_id: this.$store.getters.get_corpid,
        },
      };

      var responseData = await apiCall(inputData);
      // console.log("data", responseData.data.data[0]);
      //this.first=responseData.data.data[0]
      if (responseData.data.status == "00") {
        if (responseData.data.data != null || responseData.data.data != "") {
          this.adminUserList = responseData.data.data;
        }
        // console.log("sasssssssssssss", this.adminUserList);
        //  this.rootuservalue=this.adminUserList[0].is_root_user;
      }
    },
    async adminacces() {
      var inputData = {
        method_name: "ACCESS",
        page_no: 0,
        record_count: 0,
        page_size: 25,
        app_code: "CPORTAL",
        method_param: {
          action: "GMODULES",
          module_type: "2",
          corp_id: this.$store.getters.get_corpid,
        },
      };

      var responseData = await apiCall(inputData);
      // console.log("adminresponseData", responseData);
      if (responseData.data.data != null || responseData.data.data != "") {
        this.moduleviewarray = responseData.data.data;
      }
      /// console.log("this.moduleid", this.moduleid);
      var self = this;
      self.moduleviewarray.forEach(function (ele) {
        self.admincreatearray.push({
          modulename: ele.modulename,
          moduleid: ele.moduleid,
          has_viewer: false,
          has_maker: false,
          has_checker: false,
          has_approver: false,
          has_super_access: false,
          has_download: false,
          element: ele,
        });
      });
      // console.log("1", this.moduleviewarray);

      // console.log("2", this.admincreatearray);
      this.tempadmincreatearray = this.admincreatearray;
      // console.log("tempadmincreatearray", this.tempadmincreatearray);
    },

    close() {
      this.$refs.form.resetValidation();
      this.$refs.form.reset();
      this.admincreatearray = [];

      this.tempadmincreatearray = [];
      this.AddAdmin = false;
      this.selectedItems = [];

      this.adminacces();
    },
    openmoduleviewer(item) {
      // console.log(item);
      this.moduleItem = item;
      this.showdialog = true;
      // this.$refs.ShowViewerModule.showdialog = true;
      // console.log("openmoduleviewer", item);

      // this.$refs.ShowViewerModule.getviewers()
    },
    openmodulemaker(item) {
      this.moduleItem1 = item;
      this.showdialog1 = true;
      // this.$refs.MakerModule.showdialog = true;
      // console.log(item);
    },
    openmodulechecker(item) {
      this.moduleItem2 = item;
      this.showdialog2 = true;
      // this.$refs.CheckerModule.showdialog = true;
      //console.log(item);
    },
    openmoduleapprover(item) {
      this.moduleItem3 = item;
      this.showdialog3 = true;

      // this.$refs.ApproverModule.showdialog = true;
      // console.log(item);
    },
    openmodulesuperaccess(item) {
      // console.log("item", item);
      this.moduleItem4 = item;
      this.showdialog4 = true;
    },
    openmoduledownload(item) {
      // console.log("item", item);
      this.moduleItem5 = item;
      this.showdialog5 = true;
    },

    isNumber(evt) {
      evt = evt ? evt : window.event;
      var charCode = evt.which ? evt.which : evt.keyCode;
      if (
        charCode > 31 &&
        (charCode < 48 || charCode > 57) &&
        charCode !== 46
      ) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    openviewer(item) {
      // console.log("fdg", item);
      this.is_root_user = item.is_root_user;
      // this.$refs.viewer.viewerdialog = true;
      this.$refs.viewer.userListViewer = item;
      // console.log("lllllllllllllllll", item);
      if (item.dep_details != null) {
        this.department_array = item.dep_details.map((item) => ({
          department_id: item.dep_id.toString(),
          department_name: item.department_name,
        }));

        this.viewerdialog = true;
        this.USerId = item.userid;
        // console.log("fdg", this.USerId);
        // if (this.USerId != this.$store.getters.get_userid) {
        //   this.show = 0;
        //   console.log("show", this.show);
        // }
      }

      // var object = {};
      // for (let i = 0; i < this.department_array.length; i++) {
      //   object = {
      //     department_id: this.department_array[i].dep_id,
      //     department_name: this.department_array[i].department_name,
      //   };
      //   this.department_array.push(object);
      // }
      this.$refs.viewer.getUserAccessById();
      // this.$refs.viewer.adminacces();
      // this.$refs.viewer.getdepartmentlist = this.getdepartmentlist;
      //  console.log(this.$refs.viewer.getdepartmentlist);
    },
  },
};
</script>

<style>
.navbar {
  background: linear-gradient(to bottom, #2e4152 0%, #3c4d5d 50%, #202c37 100%);
}
</style>
